import React, { Component } from "react";
import R from 'ramda';
import {
  Card,
  Alert,
}
from "@maxmilhas/hangar-components-atomic/public";
import { css } from 'emotion';
import { luggageCardStyle } from '../../styles/luggage-card';

const luggageInfo = {
  latam: "https://www.latam.com/pt_br/informacao-para-sua-viagem/bagagem/bagagem-despachada/",
  gol: "https://www.voegol.com.br/pt/informacoes/viaje-sem-duvidas/bagagem-de-mao-e-despachada",
  azul: "https://www.voeazul.com.br/bagagem",
};

const PassengerLuggageItem = ({ passenger }) => {
  
  if (!Array.isArray(passenger.list) || passenger.list.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <div className='padding-gutter-half'>
        <strong>{`${passenger.name} ${passenger.suffix ? passenger.suffix : ''}`.trim()}</strong> tem direito a:
        { passenger.list.map((luggageItem, index) => (
          <small className='block' key={index}>
            {`${luggageItem.amount} bagagem (até ${luggageItem.weight}kg)`}
          </small>
        ))}
      </div>
    </React.Fragment>
  );
}

const FlightLuggageResume = ({ company, luggage, inbound = false }) => {
  const attributes = {
    text: 'Ida',
    icon: 'outbound'
  };

  if (inbound) {
    attributes.text = 'Volta';
    attributes.icon = 'inbound';
  }

  if(!company || !luggage) {
    return null;    
  }

  return (
    <React.Fragment>
      <div className='luggage-item'>
        <div className='luggage-header'>
          <i className={`icon icon-${attributes.icon}`} />
          <strong>{attributes.text} - </strong><span className='blue'>{company}</span>
        </div>
        { luggage && Object.keys(luggage).map((key, index) => <PassengerLuggageItem key={index} passenger={luggage[key]} />)}
        { !luggage && <small> Você não possui direito a bagagem para este voo.</small> }
      </div>
    </React.Fragment>
  );
}

export default class LuggageCard extends Component {
  constructor(props) {
    super(props);
  }

  render = () => {
    const {
      outbound,
      inbound
    } = this.props.order.flights;
    return (
      <Card
        title = "Detalhes da bagagem"
        selfOpenControl
        type = "accordion">
        <div className='col'>
          <div className={css`${luggageCardStyle}`}>
            {outbound && (
              <FlightLuggageResume company={outbound.airline} luggage={outbound.luggage || undefined} inbound={false} />
            )}
            {inbound &&  (
              <FlightLuggageResume company={inbound.airline} luggage={inbound.luggage || undefined} inbound={true} />
            )}
          </div>
        </div>
        {R.is(String, luggageInfo[outbound.airline.toLowerCase()]) && (
          <div className='col'>
            <Alert type='warning' icon={null}>
              <div className={css`text-align: center; width: 100%;`}>Confira as regras de uso da franquia de despacho de bagagem <a target="_blank" href={luggageInfo[outbound.airline.toLowerCase()]}>aqui</a>.</div>
            </Alert>
          </div>
        )}
      </Card>
    );
  }
}